module.exports = __webpack_public_path__ + "static/img/forests05.29dae3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests05.jpg
// module id = 1Src
// module chunks = 0